import './bootstrap';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, withRouter, Redirect } from "react-router-dom";
import Axios from 'axios';
import Index from './components/Index';
import AppMain from './app.mainpage';
import Billing from './jsx/Billing';
import CategoryContent from './jsx/Category';
import MenuItemContent from './jsx/MenuItem';
import NewMenuItemContent from './jsx/NewMenuItem';
import NewOrderContent from './jsx/NewOrder';
import OrderContent from './jsx/Order';
import VerifyCodeContent from './jsx/VerifyCode';
import './jsx/Config/Init';
import CartAndPinFooter from './CartAndPinFooter';
import Order from './Model/Order'
import AppData from './Model/AppData'
import PromptPinModal from './jsx/modal/PromptPinModal';
import PickupInformation from './jsx/PickupInformation';
import { CustomerProfile } from './jsx/CustomerProfile';
import { Payment } from './jsx/Payment';
import { pageReload } from './util/PageReload';
import MenuItem from './Model/MenuItem';
import OrderItem from './Model/OrderItem';
import TableSessionHelper from './Model/TableSession';
import LoginWithFirebase from './jsx/LoginWithFirebase';
import { hot } from 'react-hot-loader/root';
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'
import SelectDeliveryLocation from './app/User/SelectDeliveryLocation/SelectDeliveryLocation';
import CustomerCheckIn from './jsx/CustomerCheckIn';
import { TableType } from './components/merchant/Enum/TableType';
import SelectMerchantMenu from './jsx/SelectMerchantMenu';
import PhoneNumberAndPaxModal from './jsx/modal/PhoneNumberAndPaxModal';
import PolicyLink from './components/admin/Policy/PolicyLink';
import OrderHandler from './app/User/Handler/OrderHandler';
import DineInTableRepository from './components/repository/DineInTableRepository';
// import DiscountTierRepository from './components/repository/DiscountTierRepository';
import TemporaryTableQr from './Model/TemporaryTableQr';
import MenuScheduleRepository from './app/Merchant/Repository/MenuScheduleRepository';
import Category from './Model/Category';
import MerchantMenu from './Model/MerchantMenu';
import Merchant from './Model/Merchant';

if (module.hot) {
    module.hot.accept()
}
class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            bill: null,
            table: null,
            merchant: null,
            categories: null,
            promoLoaded: null,
            promoData: [],
            merchantMenus: [],
            filteredCategories: [],
            menuItems: null,
            filteredMenuItems: [],
            variations: null,
            orders: null,
            table_session: null,
            current_session: null,
            voucher_history: null,
            isMerchant: false,
            table_session_loading: false,
            table_loading: true,
            url: null,
            joiningTable: false,
            firebase_uid: null,
            currencyName: "RM",
            customer: {
                id: null,
                firebase_uid: null,
                name: null,
                phone_number: null
            },
            isShowPendingPaymentTimer: false,
            isShowPayBill: false,
            publicHoliday: [],
        };
        this.setVisibilityPayBill = this.setVisibilityPayBill.bind(this)
        this.isReadyFor = this.isReadyFor.bind(this)
        this.loadOrders = this.loadOrders.bind(this)
        this.isTableLoaded = this.isTableLoaded.bind(this)
        this.routes = this.routes.bind(this)
        this.loginWithFirebase = this.loginWithFirebase.bind(this)

        if (table_id == undefined || table_id == null) {
            pageReload.goTo('/home')
        }
        AppData.init(this)

        this.callbackKey = "UserApp"
    }

    componentDidMount() {
        loadProgressBar()
        Order.init(this)

        this.loadMerchantSettings()
        this.loadTableIfNull()

        $(document).off('routes.goto').on('routes.goto', (e, path) => {
            this.props.history.replace(path)
            $(document).trigger('routes.goto.completed')
        })

        // To filter Category after change of MerchantMenu selection
        $(document).off('MerchantMenu.selected').on('MerchantMenu.selected', (e) => {
            this.filterBySearchText()
        })

        // To allow test select MerchantMenu from console
        $(document).off('MerchantMenu.choose').on('MerchantMenu.choose', (e, merchantMenuId) => {
            this.setState({selectedMerchantMenuId: merchantMenuId}, this.filterBySearchText)
        })
        this.handleMultiMenuRedirect()
        this.loadPublicHolidays()
        this.loadMerchantOffDays()
        this.loadDiscountTiers()
        this.loadTemporaryTableQr()
        this.loadMenuSchedule()

        this.showPhoneNumberAndPaxModal()

        this.phoneNumberAndPaxModalRef = React.createRef()
    }
    componentWillUnmount() {
        firebase.database().ref(firebase_path + '/merchants/').off('value');
        firebase.database().ref(firebase_path + '/categories/').off('value');
        firebase.database().ref(firebase_path + '/merchant_menus/').off('value');
        if (this.state.table != null) {
            firebase.database().ref(firebase_path + '/table/' + this.state.table.id).off('value');
        }
        firebase.database().ref(firebase_path + '/orders/').off('value');
        firebase.database().ref(firebase_path + '/menu_items/').off('value');
        firebase.database().ref(firebase_path + '/variations/').off('value');
        firebase.database().ref(firebase_path + '/verify_codes/').off('value');
        firebase.database().ref(firebase_path + '/voucher_history/').off('value');
        firebase.database().ref(firebase_path + '/table_sessions/').off('value');
        firebase.database().ref(firebase_path + '/bills/').off('value');
        firebase.database().ref(firebase_path + '/merchant_settings/').off('value');
        firebase.database().ref(firebase_path + '/temporary_table_qrs/').off('value');

        if (table_session_id) {
            firebase.database().ref(firebase_path + '/table_sessions/' + table_session_id).off('child_changed');
        }

        MenuScheduleRepository.getInstance().removeCallback(null, this)
    }
    componentDidUpdate(prevProps, prevState) {
        // Load order on table session change
        if (prevState.current_session !== this.state.current_session) {
            this.setState({
                orders: [],
            }, () => this.loadOrders(table_session_id))
        }

        if (prevState.table_session !== this.state.table_session || prevState.bill !== this.state.bill) {
            this.handleTableSessionChange(this.state.table_session)
            this.handleBillChange()
        }

        // if CURRENT_SESSION BILL then
        // load ACTIVE BILL
        if (this.state.current_session != null && this.state.current_session.bill_id != null) {
            if (this.state.bill == null || (this.state.bill != null && this.state.current_session.bill_id != this.state.bill.id)) {
                this.loadBill()
            }
        }

        if (this.needLoadSession && this.state.merchant && this.state.merchantSettings) {
            this.needLoadSession = false
            this.loadSession(table_id)
        }
        if( this.state.table != null && this.state.current_session != null && !this.state.promoLoaded) {
            this.promoListData()
        }
        this.handleMultiMenuRedirect(prevProps, prevState)
        this.showPhoneNumberAndPaxModal()
        this.handleTableSessionTypeInit()
    }

    handleTableSessionTypeInit = () => {
        // Handle case where user do "select" any mode at app.mainpage and direct skill to category page
        // 1. By using Category page's direct url
        if (!this.tableSessionTypeInitOnce && this.state.table) {

            if (window.table_session_id && !this.state.current_session) {
                // Wait for tableSession to load
                return
            }
            else if (!window.table_session_id) {
                // Yet to place any order yet, continue to init
            }

            this.tableSessionTypeInitOnce = true
            OrderHandler.initTableSessionTypeForOnlineTable(this.state.table, this.state.current_session)
        }
    }

    showPhoneNumberAndPaxModal = () => {
        if (!this.isMerchantHasFeature('dine_in_capture_phone_number_and_pax')) {
            if (this.state.merchantSettings != undefined) {
                // Setting loaded and we are sure this feature is OFF.
                // Remove data from localStorage
                this.clearPhoneNumberAndPax()
                localStorage.removeItem('last_dine_in_table_session')
            }
            else {
                // Setting not loaded so we get default value of false, do nothing first
            }
            return
        }

        let phoneNumber = localStorage.getItem('dine_in_phone_number')
        let pax         = localStorage.getItem('dine_in_pax')
        let lastDineInTableSession         = localStorage.getItem('last_dine_in_table_session') || null

        if (lastDineInTableSession && (!window.table_session_id || window.table_session_id != lastDineInTableSession)) {
            // Table session has changed
            this.clearPhoneNumberAndPax()
            phoneNumber = null
            pax = null
        }
        else if (window.table_session_id != null && lastDineInTableSession == null) {
            // Just created table session, update this state
            localStorage.setItem('last_dine_in_table_session', window.table_session_id)
        }
        if ((!phoneNumber || !pax) && !this.state.isShowPhoneNumberAndPaxModal) {
            this.setState({
                isShowPhoneNumberAndPaxModal: true
            })
        }
    }

    clearPhoneNumberAndPax = () => {
        localStorage.removeItem('dine_in_phone_number')
        localStorage.removeItem('dine_in_pax')
        localStorage.removeItem('last_dine_in_table_session')
    }

    getPhoneNumberAndPaxModal = () => {
        const onClose = () => {
            let isPhoneValid = false
            if (this.phoneNumberAndPaxModalRef.current) {
                isPhoneValid = this.phoneNumberAndPaxModalRef.current.checkPhoneNumber(this.phoneNumberAndPaxModalRef.current.state.phoneNumber)
            }
            this.setState({
                isShowPhoneNumberAndPaxModal: false
            }, () => {
                if (!isPhoneValid) {
                    // Reshow modal until phone is valid
                    this.setState({
                        isShowPhoneNumberAndPaxModal: true
                    })
                }
            })
        }
        return <PhoneNumberAndPaxModal
            ref={this.phoneNumberAndPaxModalRef}
            phoneNumber={localStorage.getItem('dine_in_phone_number') || ""}
            pax={localStorage.getItem('dine_in_pax') || ""}
            onClose={onClose}
            onNo={onClose}
            onYes={(phoneNumber, pax) => {
                localStorage.setItem('dine_in_phone_number', phoneNumber)
                localStorage.setItem('dine_in_pax', pax)
                onClose()
            }}
        />
    }

    setVisibilityPayBill = (value) => {
        if (this.state.isShowPayBill != value) {
            this.setState({ isShowPayBill: value})
        }
    }

    handleMultiMenuRedirect = (prevProps, prevState) => {
        if (this.isMultiMenu()) {
            if (!this.state.selectedMerchantMenuId) {

                // if (prevState && prevState.redirectTo == this.state.redirectTo) {
                //     return
                // }

                // Merchant has multiple menu and user had not selected any yet
                if (!window.table_session_id) {
                    // This is a fresh page and user had not made any order,
                    // so force user to select a menu to begin
                    let tableQr = this.getTableQr()
                    let redirectTo = `/select_menu/${tableQr}`
                    if (this.props.location.pathname != redirectTo) {
                        if (this.state.redirectTo != redirectTo) {

                            let allowedPaths = [
                                `/${tableQr}`,
                                "/select_location"
                            ]

                            let currentPath = this.props.location.pathname
                            let isAtAllowedPath = false
                            for (let i = 0; i < allowedPaths.length; i++) {
                                if (currentPath.startsWith(allowedPaths[i])) {
                                    isAtAllowedPath = true
                                    break
                                }
                            }
                            if (!isAtAllowedPath) {
                                this.setState({redirectTo})
                            }
                        }
                        else if (this.state.redirectTo == redirectTo) {
                            // We already at the required page, stop the redirection
                            this.setState({redirectTo: null})
                        }
                    }
                }
                else if (window.table_session_id) {
                    // Already has table session
                    if (!this.state.current_session) {
                        // Wait for TableSession to load
                        // from Firebase before we do any further checking
                        return
                    }

                    if (this.state.current_session.merchant_menu_id) {
                        this.setState({
                            selectedMerchantMenuId: this.state.current_session.merchant_menu_id,
                        }, () => {
                            $(document).trigger('MerchantMenu.selected')
                        })
                    }
                }
            }
        }
    }

    loadTemporaryTableQr = () => {
        if (window.temporary_table_qr_id) {
            firebase.database().ref(firebase_path + '/temporary_table_qrs/' + window.temporary_table_qr_id)
                .on('value', snapshot => {
                    let temporaryTableQr = Object.assign(new TemporaryTableQr(), snapshot.val())
                    temporaryTableQr.key = snapshot.key
                    this.setState({
                        temporaryTableQr
                    })
                });
        }
    }
    loadMerchantSettings = () => {
        firebase.database().ref(firebase_path + '/merchant_settings/')
            .orderByChild("public_setting")
            .equalTo(`${parseInt(merchant_id)}_1` ).on('value', snapshot => {
                let settings = []
                snapshot.forEach(childSnapshot => {
                    let item = childSnapshot.val()
                    item.key = childSnapshot.key
                    settings.push(item)
                })

                // UI/Data updates may be triggered via merchant_settings update
                let stateDataToUpdate = this.updateSettingValues(settings, this.state.merchantSettings || [])

                this.setState({
                    ...stateDataToUpdate,
                    merchantSettings: settings
                })
            });
    }
    updateSettingValues = (newSetting, oldSetting) => {
        let stateToUpdate = {}
        this.checkNeedReloadData(newSetting, oldSetting)
        return stateToUpdate
    }
    checkNeedReloadData = (newSetting, oldSetting) => {
        this.reloadMerchantOffDaysIfNeeded(newSetting, oldSetting)
        this.reloadDineInTableListIfNeeded(newSetting, oldSetting)
        this.reloadMenuScheduleIfNeeded(newSetting, oldSetting)
    }
    isMerchantHasSST = () => {
        if(this.state.merchant != null && this.state.merchant != undefined){
            let gotTax = (this.state.merchant.tax_no != null)? true : false;
            return gotTax;
        }

        return false;
    }

    isMerchantHasFeature = (key) => {
        if (this.state.merchantSettings != undefined) {
            let setting = this.state.merchantSettings.find((setting) => setting.description == key)
            if (setting != undefined) {
                if (isNaN(setting.value)) {
                    return Boolean(setting.value)
                } else {
                    return setting.value > 0
                }
            }
        }
        return false
    }

    getMerchantSettingValue = (key) => {
        return this.readValueFromSettings(key, this.state.merchantSettings)
    }

    readValueFromSettings = (key, settings) => {
        if (settings !== undefined){
            let setting = settings.find((setting)=> setting.description === key)
            if (setting) {
                return setting.value
            }
        }
        return null
    }

    isTableLoaded() {
        return this.state.table !== null && this.state.table.id == table_id;
    }
    loadTableIfNull = () => {
        if (!this.loadOnce && !this.isTableLoaded(table_id)) {
            this.loadOnce = true
            if (this.state.table !== null) {
                this.setState({
                    table: null,
                    orders: null,
                    table_loading: false
                });
            }
            this.setState({
                table_loading: true
            })
            firebase.database().ref(firebase_path + '/tables/' + table_id).on('value', snapshot => {
                let item = snapshot.val()
                item.key = snapshot.key
                this.setState({
                    table: item,
                    table_loading: false
                })
                this.loadMenu(item.merchant_id)
                this.loadMerchant(item.merchant_id)
            });

            this.loadSession(table_id)
            this.loadCustomer();
        }
    }

    loadCustomer() {
        // Load customer if any
        customerId && Axios.get(`/customer/find?id=${customerId}`).then((res) => {
            this.setState({
                customer: res.data
            })
        }).catch((error) => {
            console.log(error)
        })
    }

    loadDiscountTiers = () => {
        // DiscountTierRepository.getInstance().loadAll(discountTiers => {
        //     console.log(discountTiers)
        //     this.setState({discountTiers})
        // }, this.callbackKey, this)
    }

    newSession() {
        if (!this.isMerchantHasFeature('multi_table_session_per_table')) {
            // LEGACY: Handle case when single table session per table
            if (table_session_id != null) {
                if (this.state.table_session != null && this.state.table_session.id == table_session_id) {

                    if (this.lastListenTableSessionId) {
                        firebase.database().ref(firebase_path + `/table_sessions/${this.lastListenTableSessionId}`)
                            .off('value')
                    }

                    this.lastListenTableSessionId = table_session_id
                    firebase.database().ref(firebase_path + `/table_sessions/${this.lastListenTableSessionId}`)
                        .on('value', snapshot => {
                            let tableSession = snapshot.val()
                        });
                    this.setState({
                        current_session: this.state.table_session
                    })
                }
            }
        }
        else {
            if (table_session_id != null){
                this.loadCurrentTableSession()
            }
        }
    }
    handleTableSessionChange = (tableSession) => {
        if (tableSession.active == 0 && tableSession.active_for_user_view == 0) {
            pageReload.reload()
        }
        else if (this.state.table_session.table_id != tableSession.table_id) {
            // Merchant change this table session to point to other table
            pageReload.reload()
        }
        else {
            // Nothing serious enough to trigger page reload,
            // update state to use this updated table session
            this.setState({
                table_session: tableSession
            })
        }
    }
    loadSession(tableID) {
        if (this.state.merchant == null || this.state.merchantSettings == null) {
            // Mark that we need to call loadSession() again at some other point
            // once 'merchant' and 'merchantSettings' done loading
            this.needLoadSession = true
            return
        }

        if (!this.isMerchantHasFeature('multi_table_session_per_table')) {
            const a = 10

            // Table Session
            this.setState({
                table_session_loading: true,
            })

            // LEGACY: Single table session per table mode, knowing the table id is
            // good enough. We load all the active table sessions from this table,
            // and use the latest one.
            // This will trigger bug for multi table session mode where
            // js's global 'table_session_id' and this.state.table_session.id
            // are pointing to different value.
            //
            // js's global 'table_session_id' - get from page reload or completed join table
            // this.state.table_session.id - from below firebase listener
            firebase.database().ref(firebase_path + "/table_sessions")
                .orderByChild("table_active")
                .equalTo(tableID + "_1").on("value", snapshot => {
                    let item = null
                    snapshot.forEach(childSnapshot => {
                        let snapshot = childSnapshot.val()
                        if (!snapshot.is_pay_at_counter) {
                            item = childSnapshot.val()
                            item.key = childSnapshot.key
                        }
                    })

                    if (item != null) {
                        this.setState({
                            table_session: item,
                            table_session_loading: false
                        })
                        this.newSession()
                    } else {
                        if (this.state.table_session != null) {
                            pageReload.reload()
                        }
                        table_session_id = null
                        this.setState({
                            // This to handle case where table has active previously,
                            // but the session is closed by merchant or by closing bill
                            table_session: null,
                            table_session_loading: false,
                            orders: null
                        })
                    }
                })
        }
        else {
            // Multi table session per table mode
            this.loadCurrentTableSession()
        }
    }

    /**
     * Handle changing of window.table_session_id.
     * Please use this function to assign/change table_session_id after
     * join/create table session
     */
    setCurrentTableSessionId = (tableSessionId) => {
        table_session_id = tableSessionId
        this.loadCurrentTableSession()
    }

    reloadMenuScheduleIfNeeded = (newSetting, oldSetting) => {
        const newVersion = newSetting.find(a => a.description == "menu_schedules_version")
        const oldVersion = oldSetting.find(a => a.description == "menu_schedules_version")
        if (newVersion && newVersion.value && (!oldVersion || newVersion.value != oldVersion.value)) {
            const reloadKey = MenuScheduleRepository.getInstance().getReloadEventKey()
            if (reloadKey) {
                $(document).trigger(reloadKey)
            }
        }
    }
    reloadMerchantOffDaysIfNeeded = (newSetting, oldSetting) => {
        const newMerchantOffDaysVersion = newSetting.find(a => a.description == "merchant_off_day_version")
        const oldMerchantOffDaysVersion = oldSetting.find(a => a.description == "merchant_off_day_version")
        if (newMerchantOffDaysVersion && newMerchantOffDaysVersion.value && (!oldMerchantOffDaysVersion || newMerchantOffDaysVersion.value != oldMerchantOffDaysVersion.value)) {
            this.loadMerchantOffDays()
        }
    }
    reloadDineInTableListIfNeeded = (newSetting, oldSetting) => {
        // dine_in_table_version_{tableId}.changed
        const reloadEventKey = DineInTableRepository.getInstance().getReloadEventKey()

        // Get 'dine_in_table_version_{tableId}' part
        const settingKey = reloadEventKey.split(".")[0]
        const newVersion = newSetting.find(a => a.description == settingKey)
        const oldVersion = oldSetting.find(a => a.description == settingKey)
        if (newVersion && newVersion.value && (!oldVersion || newVersion.value != oldVersion.value)) {
            $(document).trigger(DineInTableRepository.getInstance().getReloadEventKey())
        }
    }
    loadMerchantOffDays = () => {
        this.merchantOffDaysLoaded = true
        if (this.api) {
            this.api.abort()
        }
        this.api = $.ajax({
            url     : `/merchant_off_day?merchant_id=${window.merchant_id}`,
            success  : (merchantOffDays) => {
                this.setState({merchantOffDays})
            }
        })
    }

    loadCurrentTableSession = () => {
        if (!table_session_id) {
            return
        }

        // Table Session
        this.setState({
            table_session_loading: true,
        })

        const getRef = () => firebase.database().ref(firebase_path + "/table_sessions")
                .orderByChild("id")
                .equalTo(parseInt(table_session_id))

        getRef().off('value')
        getRef().on("value", snapshot => {
            let tableSession = null
            snapshot.forEach(childSnapshot => {
                let snapshot = childSnapshot.val()
                if (!snapshot.is_pay_at_counter) {
                    tableSession = childSnapshot.val()
                    tableSession.key = childSnapshot.key
                }
            })

            if (tableSession != null) {
                this.setState({
                    table_session: tableSession,
                    current_session: tableSession,
                    table_session_loading: false
                })
            } else {
                if (this.state.table_session != null) {
                    pageReload.reload()
                }
                table_session_id = null
                this.setState({
                    // This to handle case where table has active previously,
                    // but the session is closed by merchant or by closing bill
                    table_session: null,
                    table_session_loading: false,
                    orders: null
                })
            }
        })
    }
    loadOrders(currentSessionID) {
        if (this.orderRef) {
            firebase.database().ref(firebase_path + '/orders/').off('value', this.orderRef)
        }

        this.orderRef = firebase.database().ref(firebase_path + '/orders/')
            .orderByChild('table_session_id')
            .equalTo(parseInt(currentSessionID))
            .on('value', snapshot => {
                let orders = []
                let draft = false
                snapshot.forEach(childSnapshot => {
                    let item = childSnapshot.val()
                    item.key = childSnapshot.key
                    let orderItem = Object.assign(new OrderItem(), item)
                    if (item.order_status == "draft") {
                        orders.push(orderItem)
                        draft = true
                    } else if (item.order_status == "accepted") {
                        orders.push(orderItem)
                    } else if (item.order_status == "waiting_payment") {
                        orders.push(orderItem)
                    }
                    else if (item.order_status == "closed") {
                        orders.push(orderItem)
                    }
                })
                this.setState({
                    orders: orders,
                    draft: draft
                })
            });
    }

    loadBill() {
        firebase.database().ref(firebase_path + '/bills/').off('value')
        firebase.database().ref(firebase_path + '/bills/' + this.state.current_session.bill_id)
            .on('value', snapshot => {
                let item = snapshot.val()
                item.key = snapshot.key
                this.setState({
                    bill: item
                }, this.handleBillChange)
            });
    }
    handleBillChange = () => {
        const bill = this.state.bill
        if (!bill) {
            return
        }
        if (bill.status == 2 && this.state.table_session && this.state.table_session.active_for_user_view == 0) {
            pageReload.goTableLandingPage()
            return
        }
        if (bill.voucher_history_id != null) {
            this.loadVoucherHistory(bill.voucher_history_id)
        }
    }
    onClearSearchTextClicked = () => {
        this.onSearchTextChange({target: {value: ""}})
    }
    onSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        }, () => {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
            }
            this.searchTimer = setTimeout(() => {
                this.filterBySearchText()
            }, 300)
        })
    }
    filterBySearchText = () => {
        let { selectedMerchantMenuId, merchantMenus } = this.state
        let filteredMenuItems = this.filterMenuItem(this.state.menuItems || [])
        let filteredCategories = this.filterCategory(this.state.categories || [], filteredMenuItems.map(m => parseInt(m.category_id)))

        if (selectedMerchantMenuId) {
            let merchantMenu = merchantMenus.find(mm => mm.id == selectedMerchantMenuId)

            // Filter the categories if user did not select AllDayMenu
            if (!merchantMenu.is_all_day) {
                filteredCategories = filteredCategories.filter(c => {
                    let isArray = c.merchant_menu_ids != null && Array.isArray(c.merchant_menu_ids)
                    if (c.merchant_menu_ids == null || (isArray && c.merchant_menu_ids.length == 0)) {
                        // No merchant menu assigned to this category, is ALL DAY MENU
                        return true
                    }
                    if (isArray && c.merchant_menu_ids.length > 0) {
                        return c.merchant_menu_ids.find(id => id == selectedMerchantMenuId) != null
                    }
                    // Unhandled cases, return true
                    return true
                })
            }
        }
        this.setState({filteredCategories, filteredMenuItems})
    }
    filterCategory = (categories, categoryIdsToInclude) => {
        const { isSearch, searchText, menuSchedules = [] } = this.state
        if (isSearch && searchText) {
            var regex = new RegExp(searchText.replace(/ /g, ''), "i");
            categories = categories.filter(c => (c.name.replace(/ /g, '') || "").search(regex) > -1 || categoryIdsToInclude.indexOf(parseInt(c.id)) > -1)
        }

        if (menuSchedules.length) {
            const activeMenuSchedules = this.filterMenuSchedule()
            const allScheduleHash = this.state.menuSchedules.map(ms => parseInt(ms.id)).sort((a, b) => a - b).join(',')
            categories = categories.filter(c => {
                if (c.menu_schedules_ids && c.menu_schedules_ids.length) {
                    const scheduleHash = c.menu_schedules_ids.map(msId => parseInt(msId)).sort((a, b) => a - b).join(',')
                    const menuIsInAllSchedule = allScheduleHash === scheduleHash
                    return menuIsInAllSchedule || c.menu_schedules_ids.find(msId => activeMenuSchedules.find(ms => ms.id == msId)) != null
                }
                return true
            })
        }
        return categories
    }

    /**
     * Filter menu schedules that fit current timestamp, eg schedule.time_start < now() < schedule.time_end
     * @returns {int[]}
     */
    filterMenuSchedule = () => {
        let today = moment().isoWeekday()
        let yesterday = today > 1 ? today - 1 : 7 // Today is Monday (1), then yesterday is Sunday (7)
        let todaySchedules = this.state.menuSchedules.filter(ms => ms.days && ms.days.find(d => d == today))
        let yesterdaySchedules = this.state.menuSchedules.filter(ms => ms.days && ms.days.find(d => d == yesterday))

        // Menu is available today, check time
        let activeMenuSchedules = todaySchedules.concat(yesterdaySchedules).filter(ms => {
            if (ms.time_start && ms.time_end) {
                let start = moment(ms.time_start, "HH:mm")
                let end = moment(ms.time_end, "HH:mm")
                if (end.isBefore(start)) {
                    end.add(1, 'day')
                }
                if (moment().isBetween(start, end)) {
                    return true
                }
            }
            return false
        })
        return activeMenuSchedules
    }
    filterMenuItem = (menuItems) => {
        const { isSearch, searchText } = this.state
        if (isSearch && searchText) {
            var regex = new RegExp(searchText.replace(/ /g, ''), "i");
            menuItems = menuItems.filter(m => {
                return (m.name.replace(/ /g, '') || "").search(regex) > -1 || (m.description && m.description.search(regex) > -1)
            })
        }
        return menuItems
    }
    loadMenu(merchantID) {
        let isDineInTable = false
        let isPickupOrDelivery = false

        if (this.state.table) {
            isDineInTable = (this.state.table.table_type_bitwise & TableType.DINE_IN) == TableType.DINE_IN
            isPickupOrDelivery = (this.state.table.table_type_bitwise & (TableType.BIT_DELIVERY | TableType.BIT_PICKUP)) > 0
        }
        merchantID = parseInt(merchantID)
        firebase.database().ref(firebase_path + '/categories/')
            .orderByChild("merchant_id")
            .equalTo(merchantID).on('value', snapshot => {
                let categories = []
                snapshot.forEach(childSnapshot => {
                    let item = Object.assign(new Category(), childSnapshot.val())
                    if (isDineInTable && item.is_dine_in_disabled) {
                        return
                    }
                    else if (isPickupOrDelivery && item.is_delivery_disabled) {
                        return
                    }
                    item.key = childSnapshot.key
                    categories.push(item)
                })

                categories = categories.filter(c => !c.is_merchant_order_only)
                categories.sort(function(a,b) {return a.sequence - b.sequence})
                this.setState({
                    categories: categories,
                }, this.filterBySearchText)
            });
        firebase.database().ref(firebase_path + '/merchant_menus/')
            .orderByChild("merchant_id")
            .equalTo(merchantID).on('value', snapshot => {
                let merchantMenus = []
                snapshot.forEach(childSnapshot => {
                    let item = Object.assign(new MerchantMenu, childSnapshot.val())
                    item.key = childSnapshot.key
                    merchantMenus.push(item)
                })

                merchantMenus.sort((a,b) => {
                    if (!a.time_start) {
                        return -1
                    }
                    return a.time_start < b.time_start ? -1 : 1
                })

                let allDayMenuIndex = merchantMenus.findIndex(mm => mm.is_all_day)
                if (allDayMenuIndex === -1) {
                    // Add dummy AllDayMenu
                    merchantMenus.unshift(Object.assign(new MerchantMenu, {id: -1, name_en: lang.all_day_menu, is_all_day: true}))
                }
                else {
                    // Move all day menu to be the first item
                    let allDayMenu = merchantMenus.splice(allDayMenuIndex, 1)
                    merchantMenus.unshift(allDayMenu[0])
                }
                merchantMenus = merchantMenus.filter(c => !c.is_merchant_order_only)
                this.setState({merchantMenus})
            });
        firebase.database().ref(firebase_path + "/menu_items/")
            .orderByChild("merchant_id")
            .equalTo(merchantID).on("value", snapshot => {
                let menuItems = []
                snapshot.forEach(childSnapshot => {
                    let item = childSnapshot.val()
                    if (isDineInTable && item.is_dine_in_disabled) {
                        return
                    }
                    else if (isPickupOrDelivery && item.is_delivery_disabled) {
                        return
                    }

                    // Legacy handling to convert old format
                    // where each menu item can have only ONE side dish group
                    // into new format where each menu item can multiple side dish group
                    let sideDishDetail = item.side_dish_detail
                    if (sideDishDetail) {
                        // Old format do not has 'group', we set to default group 0,
                        // where at menu item side we will do similar conversion from
                        // menu_item = {
                        //     side_dish_detail: {...}
                        // }
                        // to
                        // menu_item = {
                        //     side_dish_detail: [{..., group: 0}, {..., group: 1}, ...]
                        // }
                        if (!Array.isArray(sideDishDetail)) {
                            sideDishDetail.group = 0
                            sideDishDetail.side_dish_title = item.side_dish_title
                            item.side_dish_detail = [sideDishDetail]
                        }
                    }

                    item.key = childSnapshot.key
                    item.expanded = false
                    item.newOrderQuantity = 1
                    item.name = item.name || ""
                    item.confirmOrderQuantity = 0

                    let menuItem = Object.assign(new MenuItem(), item)
                    menuItems.push(menuItem)
                })
                this.setState({
                    menuItems: menuItems,
                }, this.filterBySearchText)
            });
        firebase.database().ref(firebase_path + "/variations/")
            .orderByChild("merchant_id")
            .equalTo(merchantID)
            .on('value', snapshot => {
                let variations = []
                let choices = []
                let addons = []
                let options = []
                let sideDishes = []
                let selectedChoices = []
                let selectedAddOns = []
                let selectedOptions = []
                snapshot.forEach(childSnapshot => {
                    let item = childSnapshot.val()
                    if (isDineInTable && item.is_dine_in_disabled) {
                        return
                    }
                    else if (isPickupOrDelivery && item.is_delivery_disabled) {
                        return
                    }
                    item.key = childSnapshot.key

                    if (item.type == 1) {
                        choices.push(item)

                        let check = selectedChoices.filter((choice) => choice.item_id == item.item_id)
                        if (check.length == 0 && item.sequence == 1) {
                            selectedChoices.push(item)
                        }
                    }
                    else if (item.type == 2) {
                        // Legacy handling to convert old format
                        // where each menu item can have only ONE side dish group
                        // into new format where each menu item can multiple side dish group
                        if (typeof item.group === 'undefined') {
                            // Old format do not has 'group', we set to default group 0,
                            // where at menu item side we will do similar conversion from
                            // menu_item = {
                            //     side_dish_detail: {...}
                            // }
                            // to
                            // menu_item = {
                            //     side_dish_detail: [{..., group: 0}, {..., group: 1}, ...]
                            // }
                            item.group = 0
                        }
                        sideDishes.push(item)
                    }
                    else {
                        if (item.price != 0) {
                            addons.push(item)
                        } else {
                            options.push(item)
                        }
                    }
                    variations.push(item)
                })
                variations.sort(function (a, b) { return a.sequence - b.sequence })
                choices.sort(function (a, b) { return a.sequence - b.sequence })
                options.sort(function (a, b) { return a.sequence - b.sequence })
                addons.sort(function (a, b) { return a.sequence - b.sequence })
                sideDishes.sort(function (a, b) { return a.sequence - b.sequence })
                this.setState({
                    variations: variations,
                    variation: {
                        choices: choices,
                        addons: addons,
                        options: options,
                        sideDishes: sideDishes,
                        selectedChoices: selectedChoices,
                        selectedAddOns: selectedAddOns,
                        selectedOptions: selectedOptions
                    }
                })
            });
    }
    loadMerchant(merchantID) {
        merchantID = parseInt(merchantID)
        firebase.database().ref(firebase_path + '/merchants/').off('value')
        firebase.database().ref(firebase_path + '/merchants/' + merchantID).on('value', snapshot => {
            let item = snapshot.val()
            item.key = snapshot.key
            item = Object.assign(new Merchant, item)
            this.setState({
                merchant: item
            }, () => this.loadCountrys())
        });
    }
    loadVoucherHistory(voucherHistoryID) {
        let historyID = parseInt(voucherHistoryID)
        firebase.database().ref(firebase_path + '/voucher_history/').off('value')
        firebase.database().ref(firebase_path + '/voucher_history/' + historyID).on('value', snapshot => {
            let item = snapshot.val()
            item.key = snapshot.key
            this.setState({
                voucher_history: item
            })
        });
    }

    loginWithFirebase(firebase_uid, callback) {
        Axios.get(`/customer/get?firebase_uid=${firebase_uid}`)
            .then((res) => {
                this.setState({
                    customer: {
                        firebase_uid: firebase_uid,
                        name: res.data.name,
                        phone_number: res.data.phone_number
                    }
                }, () => {
                    callback && callback()
                })
            })
    }

    logoutFirebase() {
        this.setState({
            customer: {
                id: null,
                firebase_uid: null,
                name: null,
                phone_number: null
            }
        }, () => customerId = null)
    }

    isMultiMenu = () => {
        return this.isMerchantHasFeature('is_multi_menu')
    }
    isReadyFor(component) {
        if (this.state.current_session != null && this.state.current_session.bill_id != null && !(component instanceof Billing)) {
            return false
        } else if (component instanceof Billing) {
            return this.state.bill !== null && this.state.merchant != null
        }
        if (component instanceof CategoryContent) {
            return this.state.table !== null && this.state.categories !== null
        } else if (component instanceof MenuItemContent || component instanceof NewMenuItemContent) {
            return this.state.table !== null &&
                this.state.categories !== null &&
                this.state.menuItems !== null &&
                this.state.variations !== null
                // && (table_session_id === null || this.state.current_session !== null)
        } else if (component instanceof OrderContent || component instanceof NewOrderContent) {
            return this.state.orders !== null && this.state.table !== null && this.state.menuItems !== null && this.state.variations !== null
        } else if (component instanceof AppMain) {
            return !this.state.table_session_loading && !this.state.table_loading
        } else if (component instanceof CartAndPinFooter) {
            return !this.state.table_session_loading && !this.state.table_loading
        }
        else if (component instanceof PickupInformation) {
            return !this.state.table_loading && this.state.merchant != null
        }
        else if (component instanceof Payment) {
            return this.state.orders !== null && this.state.merchant != null
        }
        else if (component instanceof LoginWithFirebase || component instanceof CustomerProfile) {
            return true
        }
        else {
            return false
        }
    }

    isPickupConfirmed = () => {
        // Pickup confirmed, regardless paid or not paid
        return this.state.current_session != null && this.state.current_session.is_pickup_confirmed
    }

    getTableQr = () => {
        let currentPath = this.props.location.pathname
        let tableQr = currentPath.substr(currentPath.lastIndexOf('/') + 1)
        return tableQr
    }

    loadPublicHolidays() {
        $.ajax({
            url: "/public_holiday",
            type: "GET",
            success: data => {
                this.setState({
                    publicHoliday: data
                })
            },
            error: ajaxFails,
            complete: () => {

            }
        })
    }
    loadMenuSchedule() {
        MenuScheduleRepository.getInstance(this.callbackKey).loadAll((menuSchedules) => {
            this.setState({menuSchedules}, this.filterBySearchText)
        }, this.callbackKey, this)
    }

    loadCountrys() {
        $.ajax({
            url: "/country/list",
            type: "GET",
            success: allCountry => {
                this.setState({
                    countryList: allCountry,
                    }, () => this.setState({ country: this.state.countryList.find( x => x.id == this.state.merchant.country_id ) })
                )
            },
            error: ajaxFails,
            complete: () => {
                setTimeout(() => {
                    this.setState({
                        currencyName: JSON.parse(this.state.country.currency).label,
                    }, () => this.loadCurrencys())
                }, 50);
            }
        })
    }

    loadCurrencys() {
        $.ajax({
            url: "/currency/list",
            type: "GET",
            success: allCurrency => {
                this.setState({
                    currencyList: allCurrency,
                })
            },
            error: ajaxFails,
            complete: () => {
                setTimeout(() => {
                    this.setState({
                        currencyDataFound: this.state.currencyList.find( x => x.name == this.state.currencyName )
                    }, () => this.setState({ currencyValue: this.state.currencyDataFound.value }))
                }, 100);
            }
        })
    }

    promoListData = () => {
        $.ajax({
            url     : `/promo/list/${this.state.table.merchant_id}/${this.state.current_session.id}`,
            type    : 'get',
            success : (res) => {
                this.setState({
                    promoData: res ,
                    promoLoaded: true,
                    })
            }
        })
        this.setState({
            promoLoaded: true,
        })

    }

    routes() {
        if (this.state.current_session != null && this.state.current_session.bill_id != null) {
            return (
                <Switch>
                    <Route nomatch render={props => (<Billing {...props} currencyName={this.state.currencyName} app={this} />)} />
                </Switch>
            )
        }
        if (this.isPickupConfirmed()) {
            // Pickup confirmed, only allow 2 page
            // 1. Pickup page to view information
            // 2. Payment page to make payment
            let allowedPaths = [
                "/pickup",
                "/payment"
            ]

            let currentPath = this.props.location.pathname
            let isAtAllowedPath = false
            for (let i = 0; i < allowedPaths.length; i++) {
                if (currentPath.startsWith(allowedPaths[i])) {
                    isAtAllowedPath = true
                    break
                }
            }
            if (!isAtAllowedPath) {
                let tableQr = currentPath.substr(currentPath.lastIndexOf('/') + 1)
                return <Redirect to={`/pickup/${tableQr}`} />
            }
        }

        return (
            <>
                <Switch>
                    <Route path="/:tableQR" exact render={props => (<AppMain {...props} app={this} />)} />
                    <Route path="/category/:tableQR" render={props => (<CategoryContent {...props} app={this} />)} />
                    <Route path="/menu/:categoryID/:tableQR" render={props => {

                        // return <MenuItemContent {...props} app={this} />
                        if (this.isMerchantHasFeature('use_new_ui_for_user_ordering')) {
                            return <NewMenuItemContent {...props} currencyName={this.state.currencyName} app={this} />
                        }
                        else {
                            return <MenuItemContent {...props} currencyName={this.state.currencyName} app={this} />
                        }
                    }} />
                    <Route path="/order/:tableQR" render={props => {

                        if (this.isMerchantHasFeature('use_new_ui_for_user_ordering')) {
                            return <NewOrderContent {...props} currencyName={this.state.currencyName} app={this} />
                        }
                        else {
                            return <OrderContent {...props} currencyName={this.state.currencyName} app={this} />
                        }
                    }} />
                    <Route path="/verifycode/" render={props => (<VerifyCodeContent {...props} app={this} />)} />
                    <Route path="/pickup/:tableQR" render={props => (<PickupInformation {...props} currencyName={this.state.currencyName} app={this} />)} />
                    <Route path="/login/:tableQR" render={props => (<LoginWithFirebase {...props} app={this} />)} />
                    <Route path="/profile/:tableQR" render={props => (<CustomerProfile {...props} app={this} />)} />
                    <Route path="/payment/:tableQR" render={props => (<Payment {...props} currencyName={this.state.currencyName} currencyValue={this.state.currencyValue} app={this} />)} />
                    <Route path="/select_location/:tableQR" render={props => (<SelectDeliveryLocation {...props} currencyName={this.state.currencyName} app={this} /> )} />
                    <Route path="/check_in/:tableQR" render={props => (<CustomerCheckIn {...props} app={this} /> )} />
                    <Route path="/select_menu/:tableQR" render={props => (<SelectMerchantMenu {...props} app={this} /> )} />
                    <Route render={props => {
                        pageReload.goTo('/home')
                    }} />
                </Switch>
            </>
        )
    }

    changeLanguage = (value) => {
        let url = `/get_translation/${value}`
        if (window.merchant_id) {
            url += `?merchant_id=${window.merchant_id}`
        }
        $.ajax({
            url     : url,
            success : (res) => {
                window.lang = res
                window.selectedLang = value
                this.forceUpdate()
            }
        })
    }

    triggerSearchbar = () => {
        this.setState({
            isSearch: !this.state.isSearch,
            searchText: "",
        }, this.filterBySearchText)
    }

    isOrderSetBySet = () => {
        return this.getMerchantSettingValue('user_app_is_order_set_by_set') == 1
    }

    render() {
        let sessionDebug = session && JSON.stringify(session)
        let extraDebug = extra && JSON.stringify(extra)
        let warningDescription = (sessionDebug || extraDebug) && "This will be auto removed in production: "

        const { redirectTo } = this.state
        if (redirectTo && this.props.location.pathname != redirectTo) {
            return <Redirect to={redirectTo}/>
        }
        return (
                <div>
                    <div>
                        {
                            this.state.isShowPhoneNumberAndPaxModal &&
                            <Switch>
                                <Route path="/:tableQR" exact render={props => (<span></span>)} />
                                <Route render={props => {
                                    return this.getPhoneNumberAndPaxModal()
                                }} />
                            </Switch>
                        }

                        {this.routes()}
                        <Switch>
                            <Route path="/:tableQR" exact render={props => (<div></div>)} />
                            <Route path="/pickup/:tableQR" exact render={props => (<div></div>)} />
                            <Route path="/payment/:tableQR" exact render={props => (<div></div>)} />
                            <Route path="/order/:tableID" render={props => (<CartAndPinFooter {...props} currencyName={this.state.currencyName} app={this} mode="pay_bill" />)} />
                            { TableSessionHelper.hasSessionAndPin() && <Route render={props => (<CartAndPinFooter {...props} currencyName={this.state.currencyName} app={this} tableQR={table_qr} />)} />}
                        </Switch>
                    </div>

                    {this.state.joiningTable && <PromptPinModal message={lang.table_lock_pin.replace("<br>", "\n")} onClose={() => {
                        this.setState({ joiningTable: false })
                    }} />}

                    {
                        window.showPrivacyPolicy &&
                        <Switch>
                            <Route path="/:tableQR" exact render={props => <PolicyLink merchant={this.state.merchant} app={this} />} />
                        </Switch>
                    }
                </div>
        );
    }
}

export default hot(App);
window.appType = 'user'
ReactDOM.render(<Router>
    <Route path="/" render={props => {
     return <App {...props} />
    }} />
</Router>, document.getElementById('root'));

if (process.env.NODE_ENV === 'development' && module.hot)
  module.hot.accept()